<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template v-if="false" slot="left">
      <el-date-picker
        @change="delaySearch"
        style="width: 120px;"
        v-model="filteringMonth"
        type="month"
        placeholder="選擇月份"
        :clearable="false">
      </el-date-picker>

      <!-- <el-select v-model="filteringTeamBuyingID" placeholder="請選擇團購" @change="delaySearch" clearable style="width: 240px;">
        <el-option v-for="teamBuying in teamBuyingList :key="teamBuying.ID" :value="teamBuying.ID" :label="teamBuying.Tw.Title"></el-option>
      </el-select> -->

      <el-select v-if="$store.state.admin.AdminLevel >= 100" v-model="filteringBloggerID"  placeholder="請選擇部落客" @change="delaySearch" clearable>
        <el-option v-for="user in bloggers" :key="user.ID" :value="user.ID" :label="user.Profile.Name"></el-option>
      </el-select>

    </template>
    <template slot="right">
      <!-- <el-button @click="onExportExcel" style="margin-right: 20px;">匯出</el-button> -->
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">
      <!-- <el-table :data="tableDataGroupedByTeamBuying" stripe height="calc(100% - 40px)"> -->
      <el-table :data="dataList" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="團購名稱">
          <template slot-scope="scope">
            {{scope.row.Tw.Title}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="訂單數量" width="140px">
          <template slot-scope="scope">
            {{scope.row.orderCount}}
          </template>
        </el-table-column>
        <el-table-column label="分潤金額" width="140px">
          <template slot-scope="scope">
            {{scope.row.profit}}
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <!-- <el-button
              size="mini"
              round
              @click="$router.push({ name: 'order-list-of-teambuying', query: { id: scope.row.teamBuyingID }})"
            >檢視</el-button> -->
            <el-button
              size="mini"
              round
              @click="$router.push({ name: 'order-list-of-teambuying', query: { id: scope.row.ID }})"
            >檢視</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="20"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination> -->

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'
import { getOrderID } from '@/utils/filters/formatter.js'
// excel
// import ExcelGenerator from '../excel'
// import XLSXSaver from '@/utils/excel/xlsx-saver.js'

// mixin
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinLanguages, MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: '全部',
      filteringDateRange: null,
      filteringMonth: moment(),
      filteringTeamBuyingID: null,
      filteringBloggerID: null,
      // modal
      isShowAddeditModal: false,
      editingObj: null
    }
  },
  computed: {
    tableDataGroupedByTeamBuying () {
      let arr = []
      for (let order of this.tableData) {
        if (!order.TeamBuyingID) continue
        let idx = arr.findIndex(o => o.teamBuyingID == order.TeamBuyingID)
        let obj
        if (idx < 0) {
          let teamBuying = this.teamBuyingList.find(o => o.ID == order.TeamBuyingID)
          if (!teamBuying) continue
          obj = {
            teamBuyingID: order.TeamBuyingID,
            teamBuyingTitle: teamBuying.Tw.Title,
            orderCount: 0,
            orderAmountSum: 0,
            orderPaidAmountSum: 0,
            profit: 0
          }
          if (!teamBuying.BloggerUserIDs || !teamBuying.BloggerUserIDs.length) {
            obj.profit = 'N/A'
          }
          arr.push(obj)
        } else {
          obj = arr[idx]
        }
        obj.orderCount += 1
        obj.orderAmountSum += order.Amount
        obj.orderPaidAmountSum += order.PaidAmount
        if (obj.profit != 'N/A')obj.profit = parseInt(obj.orderPaidAmountSum / 20)
      }
      return arr
    },
    routeQuery () {
      let query = {
        frompage: this.currentPage
      }
      if (this.filteringStatus) query.filteringStatus = this.filteringStatus
      if (this.keyword) query.keyword = this.keyword
      if (this.filteringDateRange) query.filteringDateRange = JSON.stringify(this.filteringDateRange)
      return query
    },
    dataList () {
      // return this.$store.state.order.list.filter(o => o.TeamBuyingID > 0 && o.PaymentStatus == '已付款')
      return this.$store.state.teamBuying.list
    },
    bloggers () {
      return this.$store.state.user.list.filter(o => o.IsActive && o.AdminLevel == 10)
    },
    teamBuyingList () {
      return this.$store.state.teamBuying.list.filter(o => o.IsActive)
    }
  },
  methods: {
    // onExportExcel () {
    //   const exportExcel = () => {
    //     try {
    //       let datas = this.searchedObjs
    //       let result = ExcelGenerator.generate(this, datas)

    //       var fileName = window.prompt(
    //         '請輸入匯出Excel檔之名稱',
    //         '旬果屋購物官網-訂單匯出'
    //       )
    //       if (fileName === null) return // 取消
    //       if (!fileName) return window.alert('請輸入檔案名稱')
    //       XLSXSaver.saveAs(result, fileName)
    //     } catch (e) {
    //       alert('發生錯誤:' + e)
    //       window.console.error(`匯出異常`, e)
    //     }
    //   }

    //   // 1. load with details
    //   var ids = this.searchedObjs.map(o => o.ID)

    //   this.$services.order.getOrderListWithDetail(this, ids).then(res => {
    //     var orders = res.data.result
    //     for (let order of orders) {
    //       let idx = this.$store.state.order.list.findIndex(o => o.ID === order.ID)
    //       if (idx >= 0) this.$set(this.$store.state.order.list, idx, order)
    //       // filter again
    //       this.filterObjs()
    //     }
    //     // 2. export
    //     exportExcel()
    //   }).catch(this.$handleServiceError)
    // },
    onCreate () {
      this.editingObj = null
      this.isShowAddeditModal = true
    },
    onUpdate (obj) {
      this.editingObj = obj
      this.isShowAddeditModal = true
    },
    onObjAddedited () {
      this.searchWithoutAlertResult()
    },
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs// .slice((page - 1) * this.countPerPage, page * this.countPerPage)
    },
    setFilterStatus (value) {
      this.filteringStatus = value
      this.filterObjs()
      this.tableData = this.searchedObjs// .slice(0, this.countPerPage)
    },
    onDateRangeChanged () {
      this.filterObjs()
      this.tableData = this.searchedObjs// .slice(0, this.countPerPage)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange && !this.filteringMonth && !this.filteringTeamBuyingID && !this.filteringBloggerID) {
        this.searchedObjs = this.dataList
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        if (o.User && o.User.Username && o.User.Username.includes(this.keyword)) return true
        if (o.User && o.User.Profile && o.User.Profile.Name && o.User.Profile.Name.includes(this.keyword)) return true
        if (o.User && o.User.Profile && o.User.Profile.Email && o.User.Profile.Email.includes(this.keyword)) return true
        if (getOrderID(o).includes(this.keyword)) return true
        return false
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        if (this.filteringStatus === '未付款') return o.PaymentStatus === '未付款'
        if (this.filteringStatus === '已付款') return o.PaymentStatus === '已付款'
        if (this.filteringStatus === '交易完成') return o.OrderStatus === '已完成'
        return true
      }

      let startDate = this.filteringDateRange && moment(this.filteringDateRange[0])
      let endDate = this.filteringDateRange && moment(this.filteringDateRange[1])
      const isObjFitDateRange = o => {
        if (!this.filteringDateRange) return true
        let date = moment(o.CreatedAt)
        return (date.isBefore(endDate) && date.isAfter(startDate)) || date.isSame(startDate, 'date') || date.isSame(endDate, 'date')
      }

      let yearMonthString = null
      if (this.filteringMonth) yearMonthString = moment(this.filteringMonth).format('yyyy-MM')
      const isFitMonth = o => {
        return true
        // if (!yearMonthString) return true
        // return moment(o.CreatedAt).format('yyyy-MM') == yearMonthString
      }

      const isFitTeamBuying = o => {
        if (!this.filteringTeamBuyingID) return true
        return o.TeamBuyingID == this.filteringTeamBuyingID
      }
      const isFitBlogger = o => {
        if (!this.filteringBloggerID) return true
        return o.BloggerUserID == this.filteringBloggerID
      }

      this.searchedObjs = this.dataList.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u) && isObjFitDateRange(u) && isFitMonth(u) && isFitTeamBuying(u) && isFitBlogger(u)
      })
    },
    // askToDelete (idx, obj) {
    //   this.$confirm(`確定刪除 「${obj.TitleTw}」?`, '刪除確認', {
    //     confirmButtonText: '確定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.deleteObj(obj)
    //   })
    // }
    // deleteObj (obj) {
    //   this.$services.order.delete(this, obj.ID).then(res => {
    //     let ok = res && res.data && res.data.status === 'ok'
    //     if (ok) {
    //       let idx = this.$store.state.order.list.findIndex(
    //         o => o.ID === obj.ID
    //       )
    //       if (idx >= 0) this.$store.state.order.list.splice(idx, 1)
    //       this.filterObjs()
    //       this.tableData = this.searchedObjs.slice(
    //         (this.currentPage - 1) * 20,
    //         this.currentPage * 20
    //       )
    //       this.$message({
    //         message: `刪除成功`,
    //         type: 'success'
    //       })
    //     }
    //   }).catch(this.$handleServiceError)
    // }
    alertSearchResult () {
      if (this.tableDataGroupedByTeamBuying.length > 0) {
        this.$message({
          message: `搜尋結果共${this.tableDataGroupedByTeamBuying.length}筆符合條件`,
          duration: 1000
        })
      } else {
        this.$message({
          message: '查無符合條件資料',
          duration: 1000
        })
      }
    }
  },
  created () {
    if (this.$store.state.admin.AdminLevel == 10) {
      this.filteringBloggerID = this.$store.state.admin.ID
    }
    this.countPerPage = 99999999
    this.currentPage = parseInt(this.$route.query.page) || 1
    if (this.$route.query.filteringStatus) this.filteringStatus = this.$route.query.filteringStatus
    if (this.$route.query.filteringDateRange) this.filteringDateRange = JSON.parse(this.$route.query.filteringDateRange)
    if (this.$route.query.keyword) this.keyword = this.$route.query.keyword

    const initTableData = () => {
      this.filterObjs()
      this.onChangePage(this.currentPage)
    }
    // query...
    let promiseList = [
      // this.$services.order.getAll(this).then(res => {
      //   this.$store.state.order.list = res.data.result
      // }),
      this.$services.teamBuying.fetchDatas(this)
    ]
    if (this.$store.state.admin.AdminLevel >= 100) {
      this.$services.user.fetchDatas(this)
    }
    Promise.all(promiseList).then(res => {
      initTableData()
    }).catch(this.$handleServiceError)
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
</style>
